import { v4 as uuidv4 } from "uuid";
import storageKeys from "../constants/storageKeys";

type AuthChangeType = "login" | "logout";

export const notifyAuthChange = (type: AuthChangeType) => {
  localStorage.setItem(
    storageKeys.authChanged,
    JSON.stringify({ id: uuidv4(), type }),
  );
};

export const subscribeToAuthChanges = (
  onChange: (type: AuthChangeType) => void,
) => {
  const handleStorage = (event: StorageEvent) => {
    if (
      event.storageArea !== localStorage ||
      event.key !== storageKeys.authChanged ||
      !event.newValue ||
      event.newValue === event.oldValue
    ) {
      return;
    }

    let notification;
    try {
      notification = JSON.parse(event.newValue);
    } catch {
      return;
    }

    if (
      typeof notification?.id === "string" &&
      notification.id.length > 0 &&
      (notification.type === "login" || notification.type === "logout")
    ) {
      onChange(notification.type);
    }
  };

  // Storage events arrive only in the other tabs; never re-broadcast here.
  window.addEventListener("storage", handleStorage);

  return () => window.removeEventListener("storage", handleStorage);
};

export const getLastSavedCommands = (): string[] => {
  const lastSavedCommands = sessionStorage.getItem(
    storageKeys.lastVerifiedCommands,
  );
  const lastSavedCommandsArray = lastSavedCommands
    ? JSON.parse(lastSavedCommands)
    : [];

  return lastSavedCommandsArray.slice(0, 5);
};

export const setLastSavedCommands = (newCommands: string[]) => {
  sessionStorage.setItem(
    storageKeys.lastVerifiedCommands,
    JSON.stringify(newCommands),
  );
};
